import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useProfileFromUrl } from '@/features/company-profile/hooks/useProfileFromUrl';
import { Sidebar } from './Sidebar';
import { TopNav } from './TopNav';
import { LicenseBanner } from './LicenseBanner';
import { useUIStore } from '@/stores/uiStore';
import { useProfileKeyboardShortcuts } from '@/features/company-profile/hooks';
import { OnboardingChatbot } from '@/features/onboarding/OnboardingChatbot';

export function AppLayout() {
  // Keeps ?profile=<id> and the active profile in step, so a link to a client's
  // data can be sent to someone else and open on the same client.
  useProfileFromUrl();

  const { theme, sidebarOpen } = useUIStore();

  // Enable global keyboard shortcuts for profile management
  useProfileKeyboardShortcuts();

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
  }, [theme]);

  return (
    <div className="flex h-screen bg-background">
      <Sidebar isOpen={sidebarOpen} />

      <div className={`flex flex-1 flex-col ${sidebarOpen ? 'lg:pl-64' : ''}`}>
        <TopNav />

        <main className="flex-1 overflow-y-auto">
          <LicenseBanner />
          <Outlet />
        </main>
      </div>

      {/* Floating onboarding chatbot */}
      <OnboardingChatbot />
    </div>
  );
}
